import { render, staticRenderFns } from "./RoofCalTextSmsCustom.vue?vue&type=template&id=5012c65b&scoped=true"
import script from "./RoofCalTextSmsCustom.vue?vue&type=script&lang=js"
export * from "./RoofCalTextSmsCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5012c65b",
  null
  
)

export default component.exports